import React from 'react';
import {
  Box,
  Heading,
  Input,
  VStack,
  Text,
  Link,
  Divider,
  List,
  ListItem,
} from '@chakra-ui/react';

const GetHelpPage = () => {
  return (
    <Box p={8} bg="blue.50" minH="100vh">
      <VStack spacing={6} align="start" width="100%">
        <Heading as="h1" size="2xl" textAlign="left" width="100%">
          Get Help
        </Heading>
        <Input
          placeholder="Search FAQs, Videos, Documentation and Forum Posts"
          size="lg"
          bg="white"
          boxShadow="sm"
          width="100%"
        />
        <Divider width="100%" />

        <Box width="100%">
          <Heading as="h2" size="lg" mb={4} textAlign="left">
            Frequently Asked Questions
          </Heading>
          <List spacing={3} textAlign="left">
            <ListItem>How do I post a new job listing?</ListItem>
            <ListItem>How can I manage applications for my job postings?</ListItem>
            <ListItem>What are the best practices for writing an effective job description?</ListItem>
            <ListItem>How do I update my company profile?</ListItem>
            <ListItem>Can I schedule interviews through the platform?</ListItem>
            <ListItem>How do I contact potential candidates?</ListItem>
            <ListItem>What are the pricing plans for job providers?</ListItem>
            <ListItem>How can I improve the visibility of my job postings?</ListItem>
          </List>
        </Box>

        <Box width="100%">
          <Heading as="h2" size="lg" mb={4} textAlign="left">
            Quick Links
          </Heading>
          <VStack align="start" spacing={3} width="100%">
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Post a New Job
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Manage Active Listings
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              View Applicant Profiles
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Recruitment Best Practices Guide
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Contact Support
            </Link>
          </VStack>
        </Box>

        <Box width="100%">
          <Heading as="h2" size="lg" mb={4} textAlign="left">
            Resources
          </Heading>
          <VStack align="start" spacing={3} width="100%">
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Provider Documentation
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Video Tutorials
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Join Provider Community Forum
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Schedule a Consultation
            </Link>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default GetHelpPage;